import { useRef } from 'react';
import {
  FlatList,
  NativeScrollEvent,
  NativeSyntheticEvent,
} from 'react-native';

export interface ScrollPersistenceResult {
  listRef: React.RefObject<FlatList | null>;
  handleScroll: (event: NativeSyntheticEvent<NativeScrollEvent>) => void;
  markRestorePending: () => void;
  handleContentSizeChange: () => void;
  resetScroll: () => void;
}

const useScrollPersistence = (): ScrollPersistenceResult => {
  const listRef = useRef<FlatList | null>(null);
  const scrollOffset = useRef<number>(0);
  const isPendingRestore = useRef<boolean>(false);

  const handleScroll = useRef(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      scrollOffset.current = event.nativeEvent.contentOffset.y;
    },
  ).current;

  const markRestorePending = useRef(() => {
    if (scrollOffset.current > 0) {
      isPendingRestore.current = true;
    }
  }).current;

  const handleContentSizeChange = useRef(() => {
    if (isPendingRestore.current && listRef.current) {
      isPendingRestore.current = false;
      listRef.current.scrollToOffset({
        offset: scrollOffset.current,
        animated: false,
      });
    }
  }).current;

  const resetScroll = useRef(() => {
    scrollOffset.current = 0;
    isPendingRestore.current = false;
  }).current;

  return {
    listRef,
    handleScroll,
    markRestorePending,
    handleContentSizeChange,
    resetScroll,
  };
};

export default useScrollPersistence;
